@use 'src/globals/main';

pn-progress-bar .pn-progress-bar {
  &-label {
    margin-bottom: 0.5em;
    color: main.$gray900;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5em;
  }

  &-subtext {
    margin-top: 0.5em;
    color: main.$gray700;
    font-weight: 400;
  }

  &-container {
    overflow: hidden;
    padding: 0.0625em;
    height: 0.75em;
    border-radius: 0.5em;
  }

  &-meter {
    position: relative;
    width: 100%;
    background: main.$gray50;
    height: 0.625em;
    border-radius: 0.5em;
    box-shadow: (0 0 0 0.0625em main.$gray400);
  }

  &-value {
    position: absolute;
    top: -0.0625em;
    left: -0.0625em;

    height: 0.75em;
    background-color: main.$blue700;
    width: var(--progress-value);
    border-radius: 0.5em 0 0 0.5em;

    transition-property: width, border-radius, background-color;
    transition-duration: 0.2s, 0.2s, 0.5s;
    transition-timing-function: linear;

    &[data-valid] {
      width: calc(var(--progress-value) + 0.125em);
      background-color: main.$green500;
      border-top-right-radius: 0.5em;
      border-bottom-right-radius: 0.5em;
    }
    &[data-error] {
      background-color: main.$warning;
    }
  }
}
